import objectFitVideos from 'object-fit-videos';

function initVideoMasthead() {
	const mastheadVideo = document.querySelector('.masthead--video video');
	if (mastheadVideo) {
		objectFitVideos(mastheadVideo);
	}
}

document.addEventListener('DOMContentLoaded', initVideoMasthead);
